module.exports = __webpack_public_path__ + "img/aboutBanner.118d0ca1.png";